<template>
  <el-button-group class="action-buttons">
    <!--    <el-button-->
    <!--        type="info"-->
    <!--        icon="el-icon-edit"-->
    <!--        @click.stop="triggerSetTargetContentItem(contentItemId)"></el-button>-->
    <el-button
        v-if="!disableClone"
        type="info"
        icon="el-icon-copy-document"
        size="mini"
        @click.stop="cloneContentItem(contentItemId)"></el-button>
    <el-button
        v-if="!disableDelete"
        type="info"
        icon="el-icon-delete"
        size="mini"
        @click.stop="triggerDeleteContentItem(targetWidgetID, targetStepID, contentItemId, contentItemIndex)">
    </el-button>
  </el-button-group>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'ActionButtons',
  props: {
    contentItemId: {
      required: true,
      type: String,
    },
    contentItemIndex: {
      required: true,
      type: Number,
    },
    disableClone: {
      required: false,
      type: Boolean,
      default: false
    },
    disableDelete: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  computed: {
    targetWidgetID() {
      return this.$store.state.campaign.widget.targetWidgetID
    },
    targetStepID() {
      return this.$store.state.campaign.step.targetStepID
    },

  },
  methods: {
    ...mapActions('campaign/contentItem', [
      'cloneContentItem',
      'deleteContentItem',
    ]),
    triggerDeleteContentItem(
        widgetID, stepID, contentItemID, contentItemIndex) {
      this.deleteContentItem(
          { widgetID, stepID, contentItemID, contentItemIndex })
      // ToDo remove ContentItem from DB (or do it in the store?)
    },
  }
}
</script>